import * as actionTypes from '../actions/actionTypes'
import {updateObject} from "../../utility";

const initialState = {
    error: null,
    loading: false,
    schedulers: [],
};

const fetchSchedulersStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchSchedulersSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, schedulers: action.schedulers})
};

const fetchSchedulersFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const copySchedulerStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const copySchedulerSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, schedulers: action.schedulers})
};

const copySchedulerFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const editSchedulerStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const editSchedulerSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, schedulers: action.schedulers})
};

const editSchedulerFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SCHEDULERS_FETCH_START: return fetchSchedulersStart(state, action);
        case actionTypes.SCHEDULERS_FETCH_SUCCESS: return fetchSchedulersSuccess(state, action);
        case actionTypes.SCHEDULERS_FETCH_FAIL: return fetchSchedulersFail(state, action);
        case actionTypes.EDIT_SCHEDULER_START: return editSchedulerStart(state, action);
        case actionTypes.EDIT_SCHEDULER_SUCCESS: return editSchedulerSuccess(state, action);
        case actionTypes.EDIT_SCHEDULER_FAIL: return editSchedulerFail(state, action);
        case actionTypes.COPY_SCHEDULER_START: return copySchedulerStart(state, action);
        case actionTypes.COPY_SCHEDULER_SUCCESS: return copySchedulerSuccess(state, action);
        case actionTypes.COPY_SCHEDULER_FAIL: return copySchedulerFail(state, action);
        default: return state;
    }
};

export default reducer;